import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommerceService } from "app/core/service/app/commerce.service";
import { AccountService } from "app/core/service/app/account.service";
import { FormGroup, FormControl, FormArray } from "@angular/forms";
import { WizardComponent } from "ng2-archwizard";
import { RouterService } from "app/core/service/core/router.sevice";
import { AppState } from "app/store/app-state";

import { Store } from "@ngrx/store";
import swal from "sweetalert2";
import { userSetTokenAction, userLoginAction } from "app/store/user";

@Component({
    selector: "app-edicion-registro",
    templateUrl: "./edicion-registro.component.html",
    styleUrls: ["./edicion-registro.scss"]
  })


  export class EdicionRegistroComponent implements OnInit 
  {
    @ViewChild(WizardComponent) public wizardComp: WizardComponent;

  wizard = {
    id: 0,
    step: 1
  };
  
  

  step = 1;
  tmpRegisterId: number = 0;
  idTipoPersona: number = 0;

  isLogin = false;

  va;

  form: FormGroup;
  porcent = 50;
  postalCode: string = "0";

  userID = 0;
  isAuth = false;
  forwardOnes = true;
  totalAmount = 0;

  isPaso2Valid = false;
  isPaso4Valid = false;

  paso2Valido(event){
    this.isPaso2Valid = event;
  }

  paso4Valido(event){
    this.isPaso4Valid = event;
  }

  //Valores para Confirmar correo
  private sub: any;
  private idUser: 0;

  commerceSat: any;
  

  toggleLogin() {
    this.isLogin = !this.isLogin;
  }

  constructor(
    private store: Store<AppState>,
    private commerceService: CommerceService,
    private accountService: AccountService,
    private route: RouterService,
    private activateRoute: ActivatedRoute

  ) {
    this.store.subscribe(state => {
      this.isAuth = state.user.isAuth;
      if (state.user.data && state.user.data.id && this.userID == 0) {
        this.userID = state.user.data.id;
        this.step = 4;
        this.form.patchValue({ userID: this.userID, step: 1 });
        this.getWizard(this.userID);
      }
    });
  }

  getWizard(userID)
  {
    this.commerceService.getWizard(userID).then(result => {
      if (result != null) {
        this.commerceService.setTitulo(result.register.commerceName)
        this.wizard.id = result.id;
        this.wizard.step = result.step;
        this.commerceService.wizard.id = result.id;
        this.commerceSat = result.commerceSat;

        if (this.forwardOnes) {
          this.forwardOnes = false;
          for (var i = 0; i < this.wizard.step; i++) {
            this.wizardComp.goToStep(i);
            this.commerceService.wizard.step = i + 1;
          }
        }

        if (result)
        {
          this.store.dispatch(userSetTokenAction(result.access_token))
          this.store.dispatch(userLoginAction({ id: userID, email: "" }));

          this.idTipoPersona = result.register.legalStructure;

          this.form.patchValue({ appointment : result.appointment });
          this.form.patchValue({ finance : result.finance });
          this.form.patchValue({ general : result.general });
          this.form.patchValue({ offer : result.offer });

          this.form.patchValue({ register : result.register });
          this.form.patchValue({ registerR : result.register });

          this.totalAmount = result.offer.montoDesembolsar;
        }
      }
      
    });
  }

  goback() {
    window.scrollTo(0, 0);
    this.commerceService.wizard.step = this.wizardComp.currentStepIndex + 1;
    this.commerceService.saveWizardData().then(result => 
    {
      if (result) 
      {
        this.idTipoPersona = result.register.legalStructure;
        
        this.form.patchValue({ appointment : result.appointment });
        this.form.patchValue({ finance : result.finance });
        this.form.patchValue({ general : result.general });
        this.form.patchValue({ offer : result.offer });
        this.form.patchValue({ register : result.register });
        this.form.patchValue({ registerR : result.register });
        this.totalAmount = result.offer.montoDesembolsar;
      }
    });
  }

  goStep(step) 
  {
    window.scrollTo(0, 0);
    this.wizardComp.goToStep(step);
    this.commerceService.wizard.step = this.wizardComp.currentStepIndex + 1;
    this.commerceService.saveWizardData().then(result => 
    {
      if (result) 
      {
        this.form.patchValue({ appointment : result.appointment });
        this.form.patchValue({ finance : result.finance });
        this.form.patchValue({ general : result.general });
        this.form.patchValue({ offer : result.offer });
        this.form.patchValue({ register : result.register });
        this.form.patchValue({ registerR : result.register });
        this.totalAmount = result.offer.montoDesembolsar;
      }
    });
  }

  finishWizard() {
    this.commerceService.saveWizardData().then(result => 
    {
      if (result) 
      {
        this.idTipoPersona = result.register.legalStructure;
        this.form.patchValue({ appointment : result.appointment });
        this.form.patchValue({ finance : result.finance });
        this.form.patchValue({ general : result.general });
        this.form.patchValue({ offer : result.offer });
        this.form.patchValue({ register : result.register });
        this.form.patchValue({ registerR : result.register });
        this.totalAmount = result.offer.montoDesembolsar;
      }
    });
    this.route.go('/fin');
    
  }

  ngOnInit() 
  {
    

    this.form = new FormGroup({
      id: new FormControl(0),
      userID: new FormControl(0),
      step: new FormControl(0),
      fase: new FormControl(0),
      faseEstatus: new FormControl(0),
      contratoID: new FormControl(0),
      fechaAlta: new FormControl(''),
      estatus: new FormControl(),
      identificador: new FormControl(0)
    });
    this.form.statusChanges.subscribe(value => {
      this.commerceService.saveWizard(
        Object.assign(
          {},
          { 
          userId: this.userID,
          step: this.wizardComp.currentStepIndex 
          },
          this.form.value
          )    
        );
    });
    this.commerceService.disket.subscribe(result =>{
      this.form.patchValue(
        {
          id: result.id,
          fechaAlta: result.fechaAlta,
          identificador: result.identificador,
          estatus: result.estatus,
          fase: result.fase,
      });
    });
    
    this.sub = this.activateRoute.params.subscribe(params => {
      if(params['idUser'] != undefined)
      {
        this.idUser = params['idUser'];
        this.store.subscribe(state => {

          if(state.user.data != null)
          {
            state.user.data.id = this.idUser;
            state.user.isAuth = true;
          }
        });
      }
    });
  }

  completeForm() {
    if (this.step === 1) {
      if (this.form.value.register.postalCode) {
        this.postalCode = this.form.value.register.postalCode;
      }
    }
    this.next();
  }
  
  prev() {
    this.step--;
  }
  next() {
    this.step++;
  }

  validarPaso1()
  {
    var valid = true;
    let general = this.form.get("general");
    if(general)
    {
      if(general.get("street").value == null || general.get("street").value == ""){ valid = false; }
      if(general.get("colony").value == null || general.get("colony").value == ""){ valid = false; }

      let references = general.get("references");
      if(references)
      {
        if(references.get("referenceA").get("name").value == null || references.get("referenceA").get("name").value == ""){ valid = false; }
        if(references.get("referenceB").get("name").value == null || references.get("referenceB").get("name").value == ""){ valid = false; }
      }

      let person = general.get("personMoral");
      if(person)
      {
        //if(person.get("socialRazon").value == null || person.get("socialRazon").value == ""){ valid = false; }
        if(person.get("dateConstitution").value == null || person.get("dateConstitution").value == ""){ valid = false; }
        if(person.get("rfc").value == null || person.get("rfc").value == ""){ valid = false; }
      }
    }
    if(valid == true)
    {
      this.goStep(1);
    }
    else{
      swal({ title: "Información Incompleta", type: "warning", text: "Favor de completar la información solicitada" });
    }
  }

  validarPaso2()
  {
    this.goStep(2);
    /*if(this.isPaso2Valid == true)
    {
      this.goStep(2);
    }
    else
    {
      swal({ title: "Información Incompleta", type: "warning", text: "Favor de cargar todos los estados de cuenta" });
    }*/
  }

  validarPaso4()
  {
    if(this.isPaso4Valid== true)
    {
      this.goStep(3);
    }
    else
    {
      swal({ title: "Información Incompleta", type: "warning", text: "Favor de completar el Expediente Digital"});
    }
  }

  Save()
  {
    this.commerceService.saveWizardData().then(result => 
    {
        if (result) 
        {
            this.idTipoPersona = result.register.legalStructure;
            this.form.patchValue({ appointment : result.appointment });
            this.form.patchValue({ finance : result.finance });
            this.form.patchValue({ general : result.general });
            this.form.patchValue({ offer : result.offer });
            this.form.patchValue({ register : result.register });
            this.form.patchValue({ registerR : result.register });            
            this.totalAmount = result.offer.montoDesembolsar;
        }
    });
  }

  //getlegalstructure(value):void{
  //  alert("Here");
    //alert(event.nombre);
  //}

  
}


// WEBPACK FOOTER //
// ./src/app/page/edicion-registro/edicion-registro.ts